
import { useEffect } from 'react';
import OneErrLog from './OneErrLog'


function ErrLogList({info  ,handleEdit}){

    const hasScrollbar = () => {
        const tablebody = document.querySelector('tbody');
        if(info.length*29 <= tablebody.clientHeight) tablebody.style.width = '100%'
        else tablebody.style.width = 'calc(100% + 10px)'
    }

    useEffect(() => {
        hasScrollbar();
        window.addEventListener('resize', hasScrollbar);
        return () => {
            window.removeEventListener('resize', hasScrollbar);
        }
    }, [info])

    return (
        <tbody>
            {info.length === 0?
                <tr>
                    <td colSpan='6'>로그 내역이 존재하지 않습니다.</td>
                </tr>
            :
                info.map( log =>{
                    return(
                       <OneErrLog key={log.errLog_idx} item={log}  handleEdit={handleEdit} />
                    );
                })
            }
        </tbody>
    );

}

export default ErrLogList;